/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ../kettle-ui/~/lodash/_freeGlobal.js
 ** module id = 492
 ** module chunks = 0
 **/